import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { Config } from '../services/Config';
import { useAuth } from '../services/Auth';
import { AppLayoutContainer } from '../components/app/AppLayout';
import { useCheckoutParams } from '../components/checkout/CheckoutPage';
import { ModifySubscriptionPageContainer } from '../components/checkout/ModifySubscriptionPage/ModifySubscriptionPageContainer';
import { useRouter, useSiteRoutes } from '../services/Navigation';
import { PaymentRegionUnsupportedErrorScreen } from '../components/checkout/PaymentRegionUnsupportedErrorScreen';
import { PaymentProviderUnconfiguredErrorScreen } from '../components/checkout/PaymentProviderUnconfiguredErrorScreen';

export const Route = createFileRoute('/modify-subscription')({
  component: ModifySubscriptionRoute,
});

function ModifySubscriptionRoute() {
  const router = useRouter();
  const { logout } = useAuth();
  const {
    apiKey,

    isRegionSupported,

    asQueryString,
    subscriptionId,
  } = useCheckoutParams();

  const { routes } = useSiteRoutes();

  const handleContinueClick = () => {
    const hash = `?${asQueryString()}`;
    router.push({
      pathname: routes.checkout.path,
      hash,
    });
  };

  const handleCancelClick = (url: string) => {
    window.location.href = url;
  };

  return (
    <>
      <AppLayoutContainer
        helpAndSupportUrl={Config.APPLICATION_GENERAL_HELPARTICLE_URL}
        siteName={Config.APPLICATION_SHORT_DISPLAY_NAME}
      />
      <ModifySubscriptionPageContainer
        insightsInformationUrl={
          Config.APPLICATION_PRODUCTINFORMATION_INSIGHTS_URL
        }
        subscriptionId={subscriptionId}
        onCancelClick={handleCancelClick}
        onContinueClick={handleContinueClick}
      />

      {/* If we support the region but there's a missing ENV_VAR for the apikey */}
      {!apiKey && !!isRegionSupported && (
        <PaymentProviderUnconfiguredErrorScreen
          fullscreen={!Config.APPLICATION_FEATUREFLAG_FAKECHECKOUTLAUNCHER}
          onResolveErrorClick={() => {
            logout({ reasonCode: 'USER_INITIATED' });
          }}
        />
      )}

      {/* If we don't support the region */}
      {!isRegionSupported && (
        <PaymentRegionUnsupportedErrorScreen
          fullscreen={!Config.APPLICATION_FEATUREFLAG_FAKECHECKOUTLAUNCHER}
          onResolveErrorClick={() => {
            logout({ reasonCode: 'USER_INITIATED' });
          }}
        />
      )}
    </>
  );
}
